import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageSEO from "@/components/feature/PageSEO";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import IntroSection from "./components/IntroSection";
import TrustStats from "./components/TrustStats";
import ComparisonSection from "./components/ComparisonSection";
import ArticlesSection from "./components/ArticlesSection";
import TrendingSection from "./components/TrendingSection";
import CTASection from "./components/CTASection";

const homeSEO = {
  jsonld: [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "ACbuyspreadsheet",
      "url": (import.meta as Record<string, unknown>).env && typeof (import.meta as Record<string, unknown>).env === "object"
        ? ((import.meta as Record<string, { VITE_SITE_URL?: string }>).env?.VITE_SITE_URL || "https://acbuyspreadsheet.courses")
        : "https://acbuyspreadsheet.courses",
      "description": "The ultimate spreadsheet-based buying system for faster, smarter online purchasing. Track, organize, and optimize your shopping workflow with structured category navigation.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://kaspreadsheet.com/search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "ACbuyspreadsheet",
      "url": (import.meta as Record<string, unknown>).env && typeof (import.meta as Record<string, unknown>).env === "object"
        ? ((import.meta as Record<string, { VITE_SITE_URL?: string }>).env?.VITE_SITE_URL || "https://acbuyspreadsheet.courses")
        : "https://acbuyspreadsheet.courses",
      "description": "ACbuyspreadsheet provides a structured spreadsheet-based shopping system that organizes product categories for efficient online purchasing.",
      "sameAs": [
        "https://kaspreadsheet.com/"
      ]
    }
  ],
  title: "ACbuyspreadsheet – The Ultimate Spreadsheet-Based Buying System for Faster, Smarter Online Purchasing",
  description: "Discover how ACbuyspreadsheet helps users track, organize, and optimize purchasing workflows with a structured spreadsheet system. Compare features, explore product categories, and start smarter buying today.",
  canonicalPath: "/"
};

export default function Home() {
  return (
    <>
      <PageSEO {...homeSEO} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <IntroSection />
        <TrustStats />
        <ComparisonSection />
        <ArticlesSection />
        <TrendingSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}